import { useEffect } from "react";
import { useState } from "react"
import { toast } from "react-toastify";
import { get, post } from "../../controllers/apiController";
import Layout from "../../components/Layout";
import { Select2WColor, Select2 } from "../../components/Select2";
import DataTable from "react-data-table-component";

import * as XLSX from 'xlsx';
import MonthPicker from "../../components/MonthPicker";

const TeklifRaporu = () => {
    const [loading, setLoading] = useState(false);
    const sources = [
        { value: "Meta", label: "Meta" },
        { value: "Manuel", label: "Manuel" },
        { value: "Ads", label: "Ads" },
        { value: "Landing Page", label: "Landing Page" },
        { value: "WordPress", label: "WordPress" },
        { value: "Referans", label: "Referans" },
        { value: "Eski Müşteri", label: "Eski Müşteri" },
        { value: "Mail", label: "Mail" }
    ];
    const [selectedSources, setSelectedSources] = useState(null);

    const [leads, setLeads] = useState({ offeredLeads: null, negativeLeads: null, positiveLeads: null });

    const [selectedType, setSelectedType] = useState(0);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);

    const months = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

    const createReport = async () => {
        try {
            let response;
            if (selectedType == 0) {
                response = await post("reports/offer-report", {
                    month: selectedDate.split('-')[1],
                    year: selectedDate.split('-')[0],
                    sources: selectedSources != null ? selectedSources.map(source => source.value) : []
                });
            } else {
                response = await post("reports/offer-report", {
                    month: null,
                    year: selectedYear,
                    sources: selectedSources != null ? selectedSources.map(source => source.value) : []
                });
            }

            setLeads(response);
        } catch (err) {
            toast.error("Rapor oluşturulurken bir hata oluştu.");
        }
    }

    const paginationComponentOptions = {
        rowsPerPageText: 'Sayfa başına satır:',
        rangeSeparatorText: 'toplam',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Tümü',
        firstPageText: 'İlk',
        previousPageText: 'Önceki',
        nextPageText: 'Sonraki',
        lastPageText: 'Son',
        noRowsPerPage: false,
    };

    const customStyles = {
        noData: {
            style: {
                padding: '24px',
                textAlign: 'center',
            },
        },
        rows: {
            style: {
                padding: '20px 0',
            },
        },
        modalBackdropStyle: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1040
        }
    };

    const columns = [
        {
            name: 'ADI SOYADI',
            cell: row => (
                <div>
                    <span className="text-truncate-1-line">{row.LeadInfo.Adi_Soyadi}</span>
                </div>
            ),
            sortable: true
        },
        {
            name: 'KAYNAK',
            cell: row => (
                <div className="hstack gap-2">
                    <div className="avatar-text avatar-sm">
                        <i className={`feather-${(row.LeadInfo.Kaynak.toLowerCase() == 'meta' ? 'facebook' : (row.LeadInfo.Kaynak.toLowerCase() == 'ads' ? 'google' : 'globe'))}`}></i>
                    </div>
                    <a href="javascript:void(0);">{row.LeadInfo.Kaynak}</a>
                </div>
            ),
            sortable: true
        },
        {
            name: 'TARIH',
            cell: row => {
                const tarih = new Date(row.LeadInfo.Tarih);
                const formatliTarih = `${tarih.getDate().toString().padStart(2, '0')}.${(tarih.getMonth() + 1).toString().padStart(2, '0')}.${tarih.getFullYear()} ${tarih.getHours().toString().padStart(2, '0')}:${tarih.getMinutes().toString().padStart(2, '0')}`;
                return <span className="fw-semibold">{formatliTarih}</span>
            },
            sortable: true
        },
        {
            name: 'ETİKET',
            cell: row => {
                return (
                    <div className="d-flex gap-2">
                        <div className="badge" style={{ backgroundColor: `#${row.Etiketler[0].Etiket_Renk}`, color: `#${row.Etiketler[0].Etiket_Yazi_Renk}` }}>
                            {row.Etiketler[0].Etiket_Adi}
                        </div>
                        {row.Etiketler.length > 1 && (
                            <div className="badge" style={{ backgroundColor: "#efefef", color: "#7f7f7f" }}>
                                +{row.Etiketler.length - 1}
                            </div>
                        )}
                    </div>
                )
            },
            sortable: true
        }
    ];

    const excelDownload = async () => {
        const data = leads;

        // Excel için verileri sütun başlıklarına göre yeniden düzenleme
        const excelData = data.map(row => {
            return {
                'ADI SOYADI': row.LeadInfo.Adi_Soyadi,
                'E-POSTA ADRESİ': row.LeadInfo.E_Posta,
                'TELEFON': row.LeadInfo.Telefon,
                'KAYNAK': row.LeadInfo.Kaynak,
                'META KAMPANYA': row.LeadInfo.Kampanya,
                'UTM SOURCE': row.LeadInfo.UTM_Source,
                'UTM KAMPANYA': row.LeadInfo.UTM_Campaign,
                'UTM KELİME': row.LeadInfo.UTM_Kelime,
                'TARIH': row.LeadInfo.Tarih,
                'ETİKET': row.Etiketler.map(label => label.Etiket_Adi).join(', '),
                'TEMSİLCİ': row.Temsilci_Isim != "null null" ? row.Temsilci_Isim : "Yok",
                'IP': row.LeadInfo.IP,
                'COOKIE': row.Cookie,
                'MESAJ': row.LeadInfo.Mesaj,
                'AÇIKLAMA': row.LeadInfo.Aciklama,
                'NOTLAR': JSON.stringify(row.Notlar)
            };
        });

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Formlar");

        // Sütun genişliklerini ayarlama
        const wscols = [
            { wch: 30 }, // KAMPANYA ADI
            { wch: 15 }, // GÖSTERİMLER
            { wch: 15 }, // ERİŞİMLER
            { wch: 15 }, // TIKLAMALAR
            { wch: 10 }, // TBM
            { wch: 15 }, // FORM SAYISI
            { wch: 20 }, // SONUÇ BAŞINA ÜCRET
            { wch: 15 }  // HARCAMA
        ];
        ws['!cols'] = wscols;

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Formlar_${new Date().toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(/\//g, '.').replace(':', '.')}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
    }

    const getMonthlyStats = (positiveLeads, negativeLeads, offeredLeads, months) => {
        // Her ay için boş array oluştur
        const monthly = months.map(() => ({
            total: 0,
            positive: 0,
            negative: 0
        }));

        // Olumlu lead'leri ay ay ekle
        offeredLeads.forEach(lead => {
            const month = new Date(lead.Teklif_Tarihi).getMonth();
            monthly[month].total += 1;
        });

        // Olumlu lead'leri ay ay ekle
        positiveLeads.forEach(lead => {
            const month = new Date(lead.Teklif_Tarihi).getMonth();
            monthly[month].positive += 1;
        });

        // Olumsuz lead'leri ay ay ekle
        negativeLeads.forEach(lead => {
            const month = new Date(lead.Teklif_Tarihi).getMonth();
            monthly[month].negative += 1;
        });

        return monthly;
    };

    return (
        <Layout>
            <main className="nxl-container">
                {loading ? (
                    <div>Yükleniyor...</div>
                ) : (
                    <div className="nxl-content">
                        <div className="page-header">
                            <div className="page-header-left d-flex align-items-center">
                                <div className="page-header-title">
                                    <h5 className="m-b-10">LEVELUP CRM</h5>
                                </div>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                    <li className="breadcrumb-item">Rapor Oluştur</li>
                                </ul>
                            </div>
                        </div>
                        <div className="main-content">
                            <div className="row">
                                <div className="col-xxl-12 col-md-12">
                                    <div className="card stretch stretch-full">
                                        <div className="card-header">
                                            <h5 className="card-title">Rapor Görüntüle</h5>
                                        </div>
                                        <div className="card-body custom-card-action p-4">
                                            <div className="row mb-4 align-items-center">
                                                <div className="p-2">
                                                    <select className="form-control form-select" id="typeSelect" onChange={(e) => setSelectedType(e.target.value)}>
                                                        <option value={0} selected>Aylık</option>
                                                        <option value={1}>Yıllık</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {selectedType == 0 ? (
                                                <div className="row mb-4 align-items-center">
                                                    <label className="fw-semibold mb-2">Ay ve Yıl: </label>
                                                    <div className="p-2">
                                                        <MonthPicker placeholder="Ay ve yılı giriniz" onDateChange={(date) => setSelectedDate(date)} />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="row mb-4 align-items-center">
                                                    <label className="fw-semibold mb-2">Yıl: </label>
                                                    <div className="p-2">
                                                        <input type="number" min={2000} max={2500} step={1} className="form-control" id="year" onChange={(e) => setSelectedYear(e.target.value)} value={selectedYear} />
                                                    </div>
                                                </div>
                                            )}
                                            <div className="row mb-4 align-items-center">
                                                <label className="fw-semibold mb-2">Kaynak (<b>Zorunlu değil</b>): </label>
                                                <Select2
                                                    value={selectedSources}
                                                    key={"sourceSelect"}
                                                    options={sources}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    isMulti={true}
                                                    onChange={(e) => setSelectedSources(e)}
                                                />
                                            </div>
                                            <button onClick={createReport} className="btn btn-primary">
                                                <i className="feather-plus me-2"></i>
                                                <span>Rapor Görüntüle</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {leads.positiveLeads != null && (
                                <>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-xxl-4 col-md-6">
                                                    <div className="card stretch stretch-full" style={{ backgroundColor: '#a5b4fc', borderColor: '#98a7eb' }}>
                                                        <div className="card-body text-white">
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <div className="avatar-text avatar-xl rounded" style={{ backgroundColor: '#818cf8', border: '2px solid #a5b4fc' }}>
                                                                        <i className="feather-users text-white"></i>
                                                                    </div>
                                                                    <a href="javascript:void(0);" className="fw-semibold d-block text-white">
                                                                        <span className="d-block">Toplam Teklif</span>
                                                                        <span className="fs-24 fw-bolder d-block">{leads.offeredLeads.length}</span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xxl-4 col-md-6">
                                                    <div className="card stretch stretch-full" style={{ backgroundColor: '#6ee7b7', borderColor: '#67dbad' }}>
                                                        <div className="card-body text-white">
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <div className="avatar-text avatar-xl rounded" style={{ backgroundColor: '#34d399', border: '2px solid #6ee7b7' }}>
                                                                        <i className="feather-smile text-white"></i>
                                                                    </div>
                                                                    <a href="javascript:void(0);" className="fw-bold d-block text-white">
                                                                        <span className="d-block">Toplam Olumlu Müşteri</span>
                                                                        <span className="fs-24 fw-bolder d-block">{leads.positiveLeads.length}</span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xxl-4 col-md-6">
                                                    <div className="card stretch stretch-full" style={{ backgroundColor: '#fcd34d', borderColor: '#f0c848' }}>
                                                        <div className="card-body text-white">
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <div className="avatar-text avatar-xl rounded" style={{ backgroundColor: '#fbbf24', border: '2px solid #fcd34d' }}>
                                                                        <i className="feather-percent text-white"></i>
                                                                    </div>
                                                                    <a href="javascript:void(0);" className="fw-bold d-block text-white">
                                                                        <span className="d-block">Oran</span>
                                                                        <span className="fs-24 fw-bolder d-block">
                                                                            %{
                                                                                (() => {
                                                                                    const toplam = leads.offeredLeads?.length || 0;
                                                                                    if (toplam === 0) return "0.00";
                                                                                    const oran = (leads.positiveLeads.length / toplam) * 100;
                                                                                    if (isNaN(oran) || !isFinite(oran)) return "0.00";
                                                                                    return oran.toFixed(2);
                                                                                })()
                                                                            }
                                                                        </span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <h5>Aylar</h5>
                                                    <table className="table table-hover mt-4">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Ay</th>
                                                                <th scope="col">Toplam Teklif</th>
                                                                <th scope="col">Olumlu</th>
                                                                <th scope="col">Oran</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {months.map((month, idx) => {
                                                                const stats = getMonthlyStats(leads.positiveLeads, leads.negativeLeads, leads.offeredLeads, months)[idx];
                                                                const oran = stats.total > 0 ? ((stats.positive / stats.total) * 100).toFixed(2) : "0.00";
                                                                return (
                                                                    <tr key={month}>
                                                                        <th scope="row">{month} {selectedYear || new Date().getFullYear()}</th>
                                                                        <td>{stats.total}</td>
                                                                        <td>{stats.positive}</td>
                                                                        <td>{oran}%</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-body">
                                                    <h5>Olumlu Müşteriler</h5>
                                                    <DataTable
                                                        columns={columns}
                                                        data={leads.positiveLeads}
                                                        className="table table-hover mb-0"
                                                        pagination
                                                        responsive
                                                        noDataComponent="Görüntülenecek kayıt bulunamadı"
                                                        paginationComponentOptions={paginationComponentOptions}
                                                        customStyles={customStyles}
                                                        paginationPerPage={10}
                                                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-body">
                                                    <h5>Olumsuz Müşteriler</h5>
                                                    <DataTable
                                                        columns={columns}
                                                        data={leads.negativeLeads}
                                                        className="table table-hover mb-0"
                                                        pagination
                                                        responsive
                                                        noDataComponent="Görüntülenecek kayıt bulunamadı"
                                                        paginationComponentOptions={paginationComponentOptions}
                                                        customStyles={customStyles}
                                                        paginationPerPage={10}
                                                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </main>
        </Layout >
    );
}

export default TeklifRaporu;